import {QueryClient, QueryClientProvider as QueryClientProviderBase} from '@tanstack/react-query'
import {ReactQueryDevtools} from '@tanstack/react-query-devtools'
import React from 'react'

/**
 * По умолчанию время жизни кеша составляет 30 минут
 * Если необходимо делать время жизни кэша определенной ручки меньше или больше 30 минут,
 * то это можно сделать через опции запроса в useQuery.
 *
 * @see https://tanstack.com/query/latest/docs/framework/react/reference/useQuery
 */
const DEFAULT_CACHE_TIME = 1000 * 60 * 30 // 30 минут

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      gcTime: DEFAULT_CACHE_TIME,
      refetchOnMount: false,
      refetchOnReconnect: false,
      refetchOnWindowFocus: false,
      staleTime: Number.MAX_SAFE_INTEGER,
    },
  },
})

const QueryClientProvider: React.FC<React.PropsWithChildren<unknown>> = ({children}) => (
  <QueryClientProviderBase client={queryClient}>
    {children}
    {/* @see https://tanstack.com/query/latest/docs/framework/react/devtools#devtools-in-production */}
    <ReactQueryDevtools initialIsOpen={false} />
  </QueryClientProviderBase>
)

QueryClientProvider.displayName = 'QueryClientProvider'

export {QueryClientProvider}
